import ScrollStore, { ScrollStoreCtx } from '@/stores/ScrollStore';
import { useContext, useEffect } from 'react';

interface IBindEndReachedOptions {
  elRef: React.RefObject<HTMLElement>;
  callback: () => void;
}

export const useScrollStore = (bindEndReached?: IBindEndReachedOptions): ScrollStore => {
  const scrollStore = useContext(ScrollStoreCtx);

  useEffect(() => {
    scrollStore.bindEvent();
    return scrollStore.unbindEvent;
  }, []);

  useEffect(() => {
    bindEndReached && scrollStore.bindEndReachedEvent(bindEndReached.elRef, bindEndReached.callback);
    return scrollStore.unbindEndReachedEvent;
  }, [bindEndReached]);

  return scrollStore;
};
